<ng-content></ng-content>
@if (showLoader()) {
  <tiime-progress-spinner-loader
    diameter="20"
    mode="indeterminate"
    [color]="loaderColor()"
  ></tiime-progress-spinner-loader>
}
